import BaseView from "@core/View.js";

export default class PackageWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._packageBoxEl;
        this._parentModel = this._model._parent;
    }

    getSkuImg(item){
        let html = "";
        if (!this._parentModel._invalid) {
            html = `<div class="fl i_img">
                <img src="${item._img}" alt="">               
            </div>`;
        } else {
            let msg = this._parentModel.getInvalidMsg();
            html = `<div class="fl i_img">
                <img src="${item._img}" alt="">
                <div class="already_sold_box">
                    <p class="sold_text">${msg}</p>
                </div>
            </div>`;
        }
        return html;
    }
    itemOptionsStyle(){
        return `opacity:${(this._model._parent._invalid ) ? '0.5' : '1'}`
    }
    getItems(){
        let html = "";
        this._model._items.forEach((item) => {
            html += `<div class="clearfix form package">
                <div class="fl i_checkbox">                    
                </div>                
                ${this.getSkuImg(item)}
                <div class="form_right" style="${this.itemOptionsStyle()}">
                  <div class="i_desc">
                    <div class="title_box">
                      <h3>${item._name}</h3>
                    </div>
                  </div>
                  <div class="i_quantity"><span class="a_suit">1件/套</span> x <span class="a_num">${item._count}</span></div>
                </div>
            </div>`;
        });
        return html;
    }

    render(){
        let html = this.getItems();
        $(this._parentEl).append($(html));
    }
}